import React from 'react';
import ReactDOM from 'react-dom/client';
import { BuildersComponentsTrackingProvider } from '@gjensidige/builders-components';
import { TrackingProvider } from '@gjensidige/core-analytics';
import ErrorBoundary from '@gjensidige/service-error-boundary';

import tracker from './tracking';
import { App } from './App';

const rootElement = document.getElementsByClassName(
  'car-calculation-widget-root'
)[0];
const dataUrl = rootElement.getAttribute('data-url');
const dataObject = rootElement.getAttribute('data-object');

ReactDOM.createRoot(rootElement!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BuildersComponentsTrackingProvider options={tracker.options}>
        <TrackingProvider options={tracker.options}>
          <App additionalDataUrl={dataUrl} additionalDataObject={dataObject} />
        </TrackingProvider>
      </BuildersComponentsTrackingProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
